import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppShell } from "./components/AppShell";

const HomePage = lazy(() => import("./pages/HomePage"));
const VolumesPage = lazy(() => import("./pages/VolumesPage"));
const VolumeDetailPage = lazy(() => import("./pages/VolumeDetailPage"));
const PdfViewerPage = lazy(() => import("./pages/PdfViewerPage"));
const SearchPage = lazy(() => import("./pages/SearchPage"));
const FavoritesPage = lazy(() => import("./pages/FavoritesPage"));
const BonusesPage = lazy(() => import("./pages/BonusesPage"));
const SlidesPage = lazy(() => import("./pages/SlidesPage"));
const CertificatesPage = lazy(() => import("./pages/CertificatesPage"));
const ProgressPage = lazy(() => import("./pages/ProgressPage"));
const SupportPage = lazy(() => import("./pages/SupportPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));

const Shelled = ({ children }) => <AppShell>{children}</AppShell>;

const RouteFallback = () => (
  <div className="py-20 text-center text-slate-500">Carregando...</div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            {/* Fullscreen viewers (no shell) */}
            <Route path="/volumes/:id/viewer" element={<PdfViewerPage kind="volume" />} />
            <Route path="/bonus/:id/viewer" element={<PdfViewerPage kind="bonus" />} />
            <Route path="/bonus/slides/:id/viewer" element={<PdfViewerPage kind="slide" />} />

            {/* Shell routes */}
            <Route path="/" element={<Shelled><HomePage /></Shelled>} />
            <Route path="/volumes" element={<Shelled><VolumesPage /></Shelled>} />
            <Route path="/volumes/:id" element={<Shelled><VolumeDetailPage /></Shelled>} />
            <Route path="/pesquisar" element={<Shelled><SearchPage /></Shelled>} />
            <Route path="/favoritos" element={<Shelled><FavoritesPage /></Shelled>} />
            <Route path="/bonus" element={<Shelled><BonusesPage /></Shelled>} />
            <Route path="/bonus/slides" element={<Shelled><SlidesPage /></Shelled>} />
            <Route path="/bonus/certificados" element={<Shelled><CertificatesPage /></Shelled>} />
            <Route path="/progresso" element={<Shelled><ProgressPage /></Shelled>} />
            <Route path="/suporte" element={<Shelled><SupportPage /></Shelled>} />
            <Route path="/admin" element={<Shelled><AdminPage /></Shelled>} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
